export function simpleMemoize(func) {
    var called = false;
    var result;
    return (function () {
        if (!called) {
            called = true;
            result = func();
        }
        return result;
    });
}
